import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject, Input } from '@angular/core';

import {
  type CanvasElementBindings,
  type CanvasElementDataInputPayload,
  type CanvasElementId,
  type IoConfig,
  PropsOf,
} from '@blaze-runtime/engine-domain';
import { DRAWER_OVERLAY_ID } from '@blaze-runtime/engine-domain';
import { RenderElementContext, ViewportMode } from '@blaze-shared/elements-domain';

import {
  CanvasElementComponent,
  type ComponentSlotData,
} from '../../canvas-elements/element-component';
import { SlotNodeDirective } from '../../canvas-elements/rendering/slot-node.directive';
import { DialogBackdropService } from '../../services/dialog/dialog-backdrop.service';

export const OVERLAY_SLOT_CLASS = 'overlay-slot';

@Component({
  selector: 'be-overlay',
  imports: [NgTemplateOutlet, SlotNodeDirective],
  templateUrl: `./_overlay.component.html`,
  styleUrls: ['./_overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--dialog-backdrop-color]': 'dialogBackdropService.backdropColor()',
    '[style.--dialog-backdrop-opacity]': 'dialogBackdropService.backdropOpacity()',
    '[style.--dialog-background-blur-amount]': 'dialogBackdropService.backgroundBlurAmount()',
  },
})
export class OverlayComponent implements CanvasElementComponent<'_overlay'> {
  protected readonly dialogBackdropService = inject(DialogBackdropService);

  @Input() bindingResults: CanvasElementBindings = {};
  @Input() dataInput: CanvasElementDataInputPayload;
  @Input() elementContext: RenderElementContext | undefined;
  @Input() elementId: CanvasElementId | undefined;
  @Input() elementType!: 'breakLine';
  @Input() ioConfig?: IoConfig;
  @Input() isInEditor = false;
  @Input() ns?: CanvasElementId;
  @Input() props: PropsOf<'_overlay'> | undefined;
  @Input() slots?: ComponentSlotData<'_overlay'>;
  @Input() viewportMode: ViewportMode | undefined;
  @Input() visible?: boolean | any[]; // Fixme [MG] It can be an array of whatever "visible" data source will provide

  protected readonly overlaySlotClass = OVERLAY_SLOT_CLASS;

  @HostBinding('class') get overlayClass(): string | undefined {
    return this.slots?.slotNodesData?.main.elementId;
  }

  @HostBinding('class.DRAWER_OVERLAY') get isDrawer(): boolean {
    return this.slots?.slotNodesData?.main.elementId === DRAWER_OVERLAY_ID;
  }
}
